module.exports = __webpack_public_path__ + "img/Party Face Emoji.cdceffc9.png";